import { INLINE_LINK } from '@/components/bedrock';
import { LocalizedLink as Link } from '@/components/LocalizedLink';
import { useT } from '@/core/I18nProvider';

import type { ReactElement } from 'react';

/**
 * The closing sections of `/trust/dpa` — the related-documents cross-reference and
 * the contact section. Split from its page to keep that component under the
 * ~300-line ceiling (`.claude/rules/architecture.md`), following the
 * `TermsFooterSections` precedent in this directory. Purely presentational,
 * same keys, imports nothing back from its parent.
 */
export function DpaFooterSections(): ReactElement {
  const { t } = useT();
  return (
    <>
      <section aria-labelledby="dpa-related" className="mb-10">
        <h2
          id="dpa-related"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('dpa.related.heading')}
        </h2>
        <ul className="list-disc space-y-1 ps-6">
          <li>
            <Link className={INLINE_LINK} to="/trust/subprocessors">
              {t('dpa.related.subprocessors.link')}
            </Link>{' '}
            {t('dpa.related.subprocessors.body')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/security">
              {t('dpa.related.security.link')}
            </Link>{' '}
            {t('dpa.related.security.body')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/privacy">
              {t('dpa.related.privacy.link')}
            </Link>{' '}
            {t('dpa.related.privacy.body')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/compliance">
              {t('dpa.related.compliance.link')}
            </Link>{' '}
            {t('dpa.related.compliance.body')}
          </li>
        </ul>
      </section>

      <section aria-labelledby="dpa-contact">
        <h2
          id="dpa-contact"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('dpa.contact.heading')}
        </h2>
        <ul className="list-disc space-y-1 ps-6">
          <li>
            {t('dpa.contact.requests.before')}{' '}
            <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
              admin@syncanix.com
            </a>
            {t('dpa.contact.requests.after')}
          </li>
          <li>
            {t('dpa.contact.procurement.before')}{' '}
            <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
              admin@syncanix.com
            </a>
            {t('dpa.contact.procurement.after')}
          </li>
        </ul>
      </section>
    </>
  );
}
